module.exports = __webpack_public_path__ + "img/transaction rejected.08539222.svg";